module.exports = __webpack_public_path__ + "static/media/view1.9de5bef3.jpg";